import React from 'react'

/**
 * 'New' icon for landing page. Utilizing props to specify line color vs text color where desired
 * This icon uses the HeroIcons build structure.
 * Text inherits text color from tailwind, lines inherit 'color' prop
 */
function NewIcon(props: any) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        fill: 'currentColor',
        viewBox: '0 0 24 16',
        stroke: 'currentColor',
        'aria-hidden': 'true'
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      strokeWidth: 1,
      fill: props?.color ?? 'currentColor',
      stroke: props?.color ?? 'currentColor',
      d: 'M24 0H0V2H24V0Z'
    }),
    React.createElement('path', {
      strokeWidth: 1,
      fill: props?.color ?? 'currentColor',
      stroke: props?.color ?? 'currentColor',
      d: 'M24 14H0V16H24V14Z'
    }),
    React.createElement('path', {
      stroke: 'none',
      fill: 'currentColor',
      strokeWidth: 1,
      d: 'M1 4.5V11.5H2.314C2.314 7.865 2.266 6.205 2.266 6.205L5.285 11.5H7.154V4.5H5.83C5.835 5.682 5.868 9.743 5.868 9.743L2.855 4.5H1Z'
    }),
    React.createElement('path', {
      stroke: 'none',
      fill: 'currentColor',
      strokeWidth: 1,
      d: 'M12.963 5.716V4.5H8.96802V11.5H12.963V10.274H10.438V8.469H12.787V7.253H10.438V5.716H12.963Z'
    }),
    React.createElement('path', {
      stroke: 'none',
      fill: 'currentColor',
      strokeWidth: 1,
      d: 'M17.98 7.832C18.06 7.515 18.258 6.547 18.298 6.185C18.325 6.482 18.552 7.562 18.62 7.823L19.56 11.5H21.235L23 4.5H21.553L20.671 8.321C20.562 8.758 20.395 9.635 20.329 10.155C20.27 9.719 20.113 8.827 20.011 8.422L19 4.5H17.61C17.229 5.938 16.417 9.229 16.277 10.155C16.208 9.638 16.095 9.027 15.94 8.321L15.053 4.5H13.606L15.376 11.5H17.046L17.98 7.832Z'
    })
  )
}

export default NewIcon
